<!-- This component is taken from this Svelte REPL: https://svelte.dev/repl/75d34e46cbe64bb68b7c2ac2c61931ce?version=3.34.0 -->

<script>
  import { clamp } from 'yootils';
  import draggable from '../../utils/draggable';
  import { categoryPrice, updateCategoryPrice, categoryMaxMaxPrice } from './stores/facet-price.js';

  $: start =  $categoryPrice.minPrice / $categoryMaxMaxPrice;
  $: end =  $categoryPrice.maxPrice / $categoryMaxMaxPrice;

  let leftHandle;
  let body;
  let slider;

  function setHandlePosition (handle) {
    return function (event) {
      const { left, right } = slider.getBoundingClientRect();
      const parentWidth = right - left - 20;
      const position = Math.min(Math.max((event.detail.x - left) / parentWidth, 0), 1);

      if (handle === 'start') {
        start = position;
        end = Math.max(end, position);
      } else {
        start = Math.min(position, start);
        end = position;
      }

      updateCategoryPrice(Math.round(start * $categoryMaxMaxPrice), Math.round(end * $categoryMaxMaxPrice))
    }
  }

  function setHandlesFromBody () {
    const { width } = body.getBoundingClientRect();
    const { left, right } = slider.getBoundingClientRect();
    const parentWidth = right - left;
    const leftHandleLeft = leftHandle.getBoundingClientRect().left;
    const pxStart = clamp((leftHandleLeft + event.detail.dx) - left, 0, parentWidth - width);
    const pxEnd = clamp(pxStart + width, width, parentWidth);
    const pStart = pxStart / parentWidth;
    const pEnd = pxEnd / parentWidth;

    start = pStart;
    end = pEnd;
  }
</script>

<li class="facet-price">
  <div class="facet-price__slider" bind:this={slider}>
    <div
      class="facet-price__body"
      bind:this={body}
      use:draggable
      on:dragmove|preventDefault|stopPropagation="{setHandlesFromBody}"
      style="
        left: {100 * start}%;
        right: {100 * (1 - end)}%;
      "
    ></div>

    <div
      class="facet-price__handle"
      bind:this={leftHandle}
      data-which="start"
      use:draggable
      on:dragmove|preventDefault|stopPropagation="{setHandlePosition('start')}"
      style="
        left: {100 * start}%
      "
    ></div>

    <div
      class="facet-price__handle facet-price__handle-right"
      data-which="end"
      use:draggable
      on:dragmove|preventDefault|stopPropagation="{setHandlePosition('end')}"
      style="
        left: {100 * end}%
      "
    ></div>
  </div>
</li>
